export default [
  {
    text: '0',
    background: '#61BD45',
    color: '#ffffff',
  },
  {
    text: '32',
    background: '#EF252F',
    color: '#ffffff',
  },
  {
    text: '15',
    background: '#281925',
    color: '#ffffff',
  },
  {
    text: '19',
    background: '#EF252F',
    color: '#ffffff',
  },
  {
    text: '4',
    background: '#281925',
    color: '#ffffff',
  },
  {
    text: '21',
    background: '#EF252F',
    color: '#ffffff',
  },
  {
    text: '2',
    background: '#281925',
    color: '#ffffff',
  },
  {
    text: '25',
    background: '#EF252F',
    color: '#ffffff',
  },
  {
    text: '17',
    background: '#281925',
    color: '#ffffff',
  },
  {
    text: '34',
    background: '#EF252F',
    color: '#ffffff',
  },
  {
    text: '6',
    background: '#281925',
    color: '#ffffff',
  },
  {
    text: '27',
    background: '#EF252F',
    color: '#ffffff',
  },
  {
    text: '13',
    background: '#281925',
    color: '#ffffff',
  },
  {
    text: '36',
    background: '#EF252F',
    color: '#ffffff',
  },
  {
    text: '11',
    background: '#281925',
    color: '#ffffff',
  },
  {
    text: '30',
    background: '#EF252F',
    color: '#ffffff',
  },
  {
    text: '8',
    background: '#281925',
    color: '#ffffff',
  },
  {
    text: '23',
    background: '#EF252F',
    color: '#ffffff',
  },
  {
    text: '10',
    background: '#281925',
    color: '#ffffff',
  },
  {
    text: '5',
    background: '#EF252F',
    color: '#ffffff',
  },
  {
    text: '24',
    background: '#281925',
    color: '#ffffff',
  },
  {
    text: '16',
    background: '#EF252F',
    color: '#ffffff',
  },
  {
    text: '33',
    background: '#281925',
    color: '#ffffff',
  },
  {
    text: '1',
    background: '#EF252F',
    color: '#ffffff',
  },
  {
    text: '20',
    background: '#281925',
    color: '#ffffff',
  },
  {
    text: '14',
    background: '#EF252F',
    color: '#ffffff',
  },
  {
    text: '31',
    background: '#281925',
    color: '#ffffff',
  },
  {
    text: '9',
    background: '#EF252F',
    color: '#ffffff',
  },
  {
    text: '22',
    background: '#281925',
    color: '#ffffff',
  },
  {
    text: '18',
    background: '#EF252F',
    color: '#ffffff',
  },
  {
    text: '29',
    background: '#281925',
    color: '#ffffff',
  },
  {
    text: '7',
    background: '#EF252F',
    color: '#ffffff',
  },
  {
    text: '28',
    background: '#281925',
    color: '#ffffff',
  },
  {
    text: '12',
    background: '#EF252F',
    color: '#ffffff',
  },
  {
    text: '35',
    background: '#281925',
    color: '#ffffff',
  },
  {
    text: '3',
    background: '#EF252F',
    color: '#ffffff',
  },
  {
    text: '26',
    background: '#281925',
    color: '#ffffff',
  },
];
